/**
 |--------------------------------------------------------------------------
 | ACTIVITY : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const crm_activity = [
 {
  path: '/crm_activity/cloudcall_stats', component: require('pages/crm/reports/activity/cloudcall_stats.vue').default,
  name: 'crm_activity_cloudcall_stats',
  meta: {requiresAuth: true, title: "CRM Cloudcall Stats", icon: "fas fa-phone"}
 },
 // {
 //  path: '/crm_activity/latest', component: require('pages/crm_activity/latest.vue').default,
 //  name: 'crm_activity_latest',
 //  meta: {
 //   requiresAuth: true,
 //   authLevelRequired: userLevelGroups.crm_man_ac_con,
 //   title: "CRM Latest Activity",
 //   icon: "fas fa-history"
 //  }
 // },
 {
  path: '/crm_activity/stats', component: require('pages/crm/reports/activity/note_stats.vue').default,
  name: 'crm_note_stats',
  meta: {requiresAuth: true, title: "CRM Notes Stats", icon: "fas fa-lightbulb"}
 },
 {
    path: '/reports/workers/work_status', component: require('pages/crm/reports/workers/work_status.vue').default,
    name: 'work_status',
    meta: {requiresAuth: true, title: "Work Status", icon: "fas fa-flag-checkered"}
   },
];
export default crm_activity;
